"use client";

import { Radio as RadioPrimitive } from "@base-ui/react/radio";
import { RadioGroup as RadioGroupPrimitive } from "@base-ui/react/radio-group";
import { Circle } from "lucide-react";

import { cn } from "frontend-components/lib/utils";

function RadioGroup<Value>({
    className,
    ...props
}: RadioGroupPrimitive.Props<Value> & { className?: string }) {
    return (
        <RadioGroupPrimitive
            data-slot="radio-group"
            className={cn("grid gap-3", className)}
            {...props}
        />
    );
}

function RadioGroupItem({
    className,
    ...props
}: RadioPrimitive.Root.Props & { className?: string }) {
    return (
        <RadioPrimitive.Root
            data-slot="radio-group-item"
            className={cn(
                "peer relative mt-0.5 inline-flex size-4 shrink-0 items-center justify-center rounded-full border border-input text-primary shadow-xs outline-none transition-[color,box-shadow] focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
                className,
            )}
            {...props}
        >
            <RadioPrimitive.Indicator
                data-slot="radio-group-indicator"
                className="absolute inset-0 flex items-center justify-center"
            >
                <Circle className="size-2 fill-current text-current" />
            </RadioPrimitive.Indicator>
        </RadioPrimitive.Root>
    );
}

export { RadioGroup, RadioGroupItem, RadioPrimitive as Radio };
